import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ metrics }) => {
  const getMetricColor = (value, threshold) => {
    if (value >= threshold?.good) return 'text-success';
    if (value >= threshold?.warning) return 'text-warning';
    return 'text-error';
  };

  const getTrendIcon = (trend) => {
    if (trend > 0) return { name: 'TrendingUp', color: 'text-success' };
    if (trend < 0) return { name: 'TrendingDown', color: 'text-error' };
    return { name: 'Minus', color: 'text-muted-foreground' };
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Target" size={20} className="text-primary" />
          </div>
          <div className={`flex items-center gap-1 text-xs ${getTrendIcon(metrics?.etaAccuracy?.trend)?.color}`}>
            <Icon name={getTrendIcon(metrics?.etaAccuracy?.trend)?.name} size={14} />
            <span>{Math.abs(metrics?.etaAccuracy?.trend)}%</span>
          </div>
        </div>
        <div className="mb-1">
          <span className={`text-2xl font-bold ${getMetricColor(metrics?.etaAccuracy?.value, { good: 90, warning: 80 })}`}>
            {metrics?.etaAccuracy?.value}%
          </span>
        </div>
        <div className="text-sm text-muted-foreground">Précision ETA</div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="CheckCircle" size={20} className="text-success" />
          </div>
          <div className={`flex items-center gap-1 text-xs ${getTrendIcon(metrics?.appointmentAdherence?.trend)?.color}`}>
            <Icon name={getTrendIcon(metrics?.appointmentAdherence?.trend)?.name} size={14} />
            <span>{Math.abs(metrics?.appointmentAdherence?.trend)}%</span>
          </div>
        </div>
        <div className="mb-1">
          <span className={`text-2xl font-bold ${getMetricColor(metrics?.appointmentAdherence?.value, { good: 95, warning: 90 })}`}>
            {metrics?.appointmentAdherence?.value}%
          </span>
        </div>
        <div className="text-sm text-muted-foreground">Respect des RDV</div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center">
            <Icon name="UserX" size={20} className="text-warning" />
          </div>
          <div className={`flex items-center gap-1 text-xs ${getTrendIcon(-metrics?.noShowRate?.trend)?.color}`}>
            <Icon name={getTrendIcon(-metrics?.noShowRate?.trend)?.name} size={14} />
            <span>{Math.abs(metrics?.noShowRate?.trend)}%</span>
          </div>
        </div>
        <div className="mb-1">
          <span className={`text-2xl font-bold ${getMetricColor(100 - metrics?.noShowRate?.value, { good: 95, warning: 90 })}`}>
            {metrics?.noShowRate?.value}%
          </span>
        </div>
        <div className="text-sm text-muted-foreground">Taux d'absence</div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="w-10 h-10 rounded-lg bg-secondary/10 flex items-center justify-center">
            <Icon name="Clock" size={20} className="text-secondary" />
          </div>
          <div className={`flex items-center gap-1 text-xs ${getTrendIcon(-metrics?.avgInterventionTime?.trend)?.color}`}>
            <Icon name={getTrendIcon(-metrics?.avgInterventionTime?.trend)?.name} size={14} />
            <span>{Math.abs(metrics?.avgInterventionTime?.trend)} min</span>
          </div>
        </div>
        <div className="mb-1">
          <span className="text-2xl font-bold text-foreground">
            {metrics?.avgInterventionTime?.value} min
          </span>
        </div>
        <div className="text-sm text-muted-foreground">Temps moyen</div>
      </div>
    </div>
  );
};

export default PerformanceMetrics;